<div class="map-page-container" *ngIf="map_item">
  <h1 class="">{{map_item.name}}</h1>
  <img src="{{getMapUrl()}}">
</div>
